export default function Divider(theme) {
  return {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.divider,
        },
        vertical: {
          borderRightWidth: 1,
        },
        horizontal: {
          borderBottomWidth: 1,
        },
      },
    },
  };
}

